export default "__VITE_ASSET__DDPqHij9__"